import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { CreativeTypeKey } from '../../../graphql/generated/graphql_offer';
import { SPACING_UNIT } from '../../constant/spacing';
import CreativeFormatCreativeTypeIcon from './CreativeFormatCreativeTypeIcon';

interface Props {
  creativeType: CreativeTypeKey;
  className?: string;
}

const CreativeFormatCreativeTypeLabel = ({ creativeType, className }: ClassAttributes<HTMLElement> & Props) => (
  <Root className={className}>
    <Icon creativeType={creativeType} />
    <Label>
      <FormattedMessage id={`creative_format.creative_type.${creativeType}`} />
    </Label>
  </Root>
);

const Root = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
});

const Icon = styled(CreativeFormatCreativeTypeIcon)({
  marginRight: SPACING_UNIT,
});

const Label = styled(Typography)({
  fontSize: '0.8125rem',
  lineHeight: 1,
});

export default CreativeFormatCreativeTypeLabel;
